class SlideshowVideoLoader extends HTMLElement {
  constructor() {
    super();
    this.desktopQuery = window.matchMedia("(min-width: 768px)");
    this.loadDesktopVideos = this.loadDesktopVideos.bind(this);
  }

  connectedCallback() {
    if (this.desktopQuery.matches) {
      this.showSurfaceWrapper();   // ← Only runs on desktop
    }
    this.loadDesktopVideos();
    this.desktopQuery.addEventListener("change", this.loadDesktopVideos);
  }

  disconnectedCallback() {
    this.desktopQuery.removeEventListener("change", this.loadDesktopVideos);
  }

  loadDesktopVideos() {
    if (!this.desktopQuery.matches) return;

    const templates = this.querySelectorAll(".desktop-video-template");

    templates.forEach((tmpl) => {
      if (tmpl.dataset.loaded === "true") return;

      const posterWrapper = tmpl.previousElementSibling;
      const poster = posterWrapper?.querySelector(".desktop-video-poster");
      const playBtn = posterWrapper?.querySelector(".video-play-btn");

      // Get video wrapper + template
      const targetWrapper = tmpl.content.querySelector(
        ".desktop-video-wrapper"
      );
      const templateEl = tmpl.content.querySelector("[data-video-template]");
      const videoHTML = templateEl?.innerHTML.trim();

      if (!targetWrapper || !templateEl || !videoHTML) return;

      if (!poster || !playBtn) {
        this.showSurfaceWrapper();

        targetWrapper.innerHTML = videoHTML;

        // Insert video after the template
        tmpl.insertAdjacentElement("afterend", targetWrapper);

        this.autoPlayInsertedVideo(targetWrapper);

        tmpl.dataset.loaded = "true";
        return;
      }

      playBtn.addEventListener(
        "click",
        () => {
          poster.classList.add("fade-out");

          setTimeout(() => {
            this.showSurfaceWrapper();

            posterWrapper.replaceWith(targetWrapper);

            targetWrapper.innerHTML = videoHTML;

            this.autoPlayInsertedVideo(targetWrapper);

            tmpl.dataset.loaded = "true";
          }, 350);
        },
        { once: true }
      );
    });
  }

  showSurfaceWrapper() {
    const surfaceWrapper = this.closest(".surface-wrapper");
    if (surfaceWrapper) {
      surfaceWrapper.style.display = "block";
    }
  }

  autoPlayInsertedVideo(wrapper) {
    const videoTag = wrapper.querySelector("video");
    const videoMedia = wrapper.querySelector("video-media");

    if (videoTag) {
      videoTag
        .play()
        .then(() => {
          if (videoMedia) videoMedia.setAttribute("playing", "");
        })
        .catch(() => {});
    }
  }
}

customElements.define("slideshow-video-loader", SlideshowVideoLoader);